module.exports = __webpack_public_path__ + "assets/1792649897182/img/fixaddress-start-topbg.aad9a02d.png";